import React from 'react';
import Text from '@rexlabs/text';

export default (props) => <Text is='h1' {...props} type={['HEADING']} />;
